import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  OnDestroy,
  ChangeDetectorRef,
  OnInit,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ShopItemModel } from 'src/app/api/models/shop-item.model';
import { ProductModalComponent } from '../product-modal/product-modal.component';
import { Subscription } from 'rxjs';
import { CartService } from 'src/app/api/services/cart.service';
import { SnackBarService } from 'src/app/api/services/snack-bar.service';
import { MatTableDataSource } from '@angular/material/table';
import { DialogProductCampaignComponent } from 'src/app/Custom/product-shop/dialog-product-campaign/dialog-product-campaign.component';
import { CustomIconsService } from 'src/app/api/services/custom-icons.service';
import { ProfileDataRequest } from 'src/app/api/models/perfil';
import { PerfilService } from 'src/app/api/services/perfil.service';
import { CartProductModel } from 'src/app/api/models/checkout';

@Component({
    selector: 'app-product-shop-list',
    templateUrl: './product-shop-list.component.html',
    styleUrls: ['./product-shop-list.component.css'],
    standalone: false
})
export class ProductShopListComponent implements OnInit, OnChanges, OnDestroy {
  @Input() shopItems!: Array<ShopItemModel>;
  @Output() isModalOpen = new EventEmitter<boolean>();
  @Input() isPageChange: boolean = false;
  @Input() sortOption: string = 'none';
  @Input() product!: ShopItemModel;
  showCampaignProductDiv: boolean = false;
  productData!: ShopItemModel;
  unsubscribe: Subscription = new Subscription();
  currentOpenProductId: string | null = null;
  shopItemWrappers: MatTableDataSource<ShopItemModel> =
    new MatTableDataSource();

  user!: ProfileDataRequest;
  displayedColumnsExtract: string[] = [];
  columnsMap: Record<string, string[]> = {
    Laboratorio: [
      'codigo',
      'produto',
      'desc',
      'Desconto manual',
      'bonus manual',
      'info',
      'qtd',
      'stock',
      'preco',
      'iva',
    ],
    Default: [
      'codigo',
      'produto',
      'desc',
      'info',
      'qtd',
      'stock',
      'preco',
      'iva',
    ],
  };


  constructor(
    public dialog: MatDialog,
    private cartService: CartService,
    private snackBarService: SnackBarService,
    private cdr: ChangeDetectorRef,
    private icons: CustomIconsService,
    private perfilService: PerfilService,
  
  ) { }

  ngOnInit(): void {
    this.user = this.perfilService.getCurrentUserInfo();
    this.displayedColumnsExtract = this.columnsMap[this.user.role] ?? this.columnsMap['Default'];  
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['shopItems'] && changes['shopItems'].currentValue) {
      this.shopItemWrappers.data = this.shopItems;
    }
    if (changes['sortOption'] && changes['sortOption'].currentValue) {
      this.shopItemWrappers.data = this.shopItemWrappers.data.sort((a, b) => {
        if (this.sortOption === 'preco-mais') {
          return a.currentPrice - b.currentPrice;
        } else if (this.sortOption === 'preco-menos') {
          return b.currentPrice - a.currentPrice;
        } else if (this.sortOption === 'stock-menos') {
          return a.stock - b.stock;
        } else if (this.sortOption === 'stock-mais') {
          return b.stock - a.stock;
        } else {
          return 0;
        }
      });
    }
  }

  showCampaignProduct(productId: string): void {
    if (this.currentOpenProductId === productId) {
      this.currentOpenProductId = null;
    } else {
      this.currentOpenProductId = productId;
    }
  }

  isProductOpen(productId: string): boolean {
    return this.currentOpenProductId === productId;
  }


  animationState = 'start';
  private productQueue: ShopItemModel[] = [];
  private animationTimeout: any;
  isProcessing = false;

  addQuantityClick(shopItemWrapper: ShopItemModel) {
    this.productQueue.push(shopItemWrapper);

    if (!this.isProcessing) {
      this.startProcessing();
    }

    clearTimeout(this.animationTimeout);
    this.animationTimeout = setTimeout(() => {
      this.finalizeUpdate(true);
    }, 500);
  }

  private finalizeUpdate(isAdding: boolean): void {
    this.isProcessing = true;
    const lastProduct = this.productQueue[this.productQueue.length - 1];
    if (lastProduct) {
      if (isAdding) {
        this.unsubscribe.add(
          this.cartService.increaseCartMethod(lastProduct, false, true).subscribe({
            next: (resp) => {
              if (resp) {
                this.snackBarService.openSnackBar(
                  'Produto adicionado ao carrinho!',
                  '#0AA174',
                  '../../assets/Icons/correct.png'
                );
              }
              this.isProcessing = false;
            }
          })
        );
      }
      else {
        this.unsubscribe.add(
          this.cartService
            .decreaseCartMethod(lastProduct, false, true)
            .subscribe((operation) => {
              setTimeout(() => {
                if (operation) {
                  this.snackBarService.openSnackBar(
                    'Produto removido do carrinho!',
                    '#0AA174',
                    '../../assets/Icons/correct.png'
                  );
                }
                this.isProcessing = false;
              }, 250);
            })
        );
      }
    }
  }

  startProcessing(): void {
    if (this.productQueue.length === 0) {
      this.isProcessing = false;
      return;
    }
    const shopItemWrapper = this.productQueue[this.productQueue.length - 1];
    shopItemWrapper.productQuantity = Number(shopItemWrapper.productQuantity) || 0;
    shopItemWrapper.productQuantity += 1;

    this.unsubscribe.add(
      this.cartService
        .increaseCartMethod(shopItemWrapper, false, false)
        .subscribe()
    );
  }

  removeQuantityClick(shopItem: ShopItemModel): void {
    this.productQueue.push(shopItem);

    if (!this.isProcessing) {
      this.startProcessingRemove();
    }

    clearTimeout(this.animationTimeout);
    this.animationTimeout = setTimeout(() => {
      this.finalizeUpdate(false);
    }, 500);
  }

  startProcessingRemove(): void {
    const shopItemWrapper = this.productQueue[this.productQueue.length - 1];
    if (shopItemWrapper.productQuantity > 0) {
      shopItemWrapper.productQuantity -= 1;
      this.unsubscribe.add(
        this.cartService
          .decreaseCartMethod(shopItemWrapper, false, false)
          .subscribe((operation) => {
            if (operation) {
              this.snackBarService.openSnackBar(
                'Quantidade reduzida do carrinho!',
                '#0AA174',
                '../../assets/Icons/correct.png'
              );
            }
          })
      );
    }
  }

  openProductDetails(product: ShopItemModel): void {
    this.isModalOpen.emit(true);
    this.dialog.open(ProductModalComponent, {
      data: product,
    });
    this.unsubscribe.add(
      this.dialog.afterAllClosed.subscribe((resp) =>
        this.isModalOpen.emit(false)
      )
    );
  }

  onKeyDown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const currentValue = input.value;
    if (+currentValue >= 1000 && !this.isControlKey(event)) {
      event.preventDefault();
    }
  }

  isControlKey(event: KeyboardEvent): boolean {
    const controlKeys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Backspace', 'Delete', 'Tab'];
    return controlKeys.includes(event.key);
  }

  onEnterPress(inputElement: HTMLInputElement): void {
    inputElement.blur();
  }

  addDiscountQuantityClick(shopItem: ShopItemModel): void {
    const currentCart = this.cartService.getSessionCart()
    const currentCartProduct = currentCart.find((p: CartProductModel) => p.productId === shopItem.reference);
    if (currentCartProduct?.labFlashDiscount == 100){
      this.snackBarService.openSnackBar(
        'Desconto máximo atingido!',
        '#F97066',
        '../../../../assets/Icons/ErrorIcon.png'
      );
      return
    }

    this.unsubscribe.add(this.cartService.increaseDiscountQuantityCartMethod(shopItem));

    const savedCart = this.cartService.getSessionCart()
    const sessionCartProduct = savedCart.find((p: CartProductModel) => p.productId === shopItem.reference);
    if (sessionCartProduct) 
      shopItem.labFlashDiscount = sessionCartProduct.labFlashDiscount;
    
  }

  onDiscountFocus(event: FocusEvent, shopItem: ShopItemModel): void {
    const input = event.target as HTMLInputElement;
    input.dataset['prev'] = shopItem.labFlashDiscount?.toString() ?? "0";
  }

  changeDiscountQuantity(event: FocusEvent, shopItem: ShopItemModel): void {
    const input = event.target as HTMLInputElement;
    const numericValue = parseFloat(input.value.replace(',', '.'));
    const oldValue = Number(input.dataset['prev'] ?? 0);

    if (numericValue === oldValue || isNaN(numericValue) || numericValue < 0) {
      shopItem.labFlashDiscount = oldValue;
    } else {
      if (numericValue > 100){
        this.snackBarService.openSnackBar(
          'Desconto máximo ultrapassado!',
          '#F97066',
          '../../../../assets/Icons/ErrorIcon.png'
        );
        
        shopItem.labFlashDiscount = oldValue;
        return
      }
      this.unsubscribe.add(
        this.cartService.changeDiscountQuantityCartMethod(shopItem, numericValue)
      );
    }

    // update prev value for the next edit
    input.dataset['prev'] = shopItem.labFlashDiscount!.toString();
  }


  removeDiscountQuantityClick(shopItem: ShopItemModel): void { 
    this.unsubscribe.add(this.cartService.decreaseDiscountQuantityCartMethod(shopItem)); 
    
    const savedCart = this.cartService.getSessionCart()
    const sessionCartProduct = savedCart.find((p: CartProductModel) => p.productId === shopItem.reference);
    if (sessionCartProduct) 
      shopItem.labFlashDiscount = sessionCartProduct.labFlashDiscount;
    else
      shopItem.labFlashDiscount = 0
  }


  addBonusDiscountQuantityClick(shopItem: ShopItemModel): void {
    this.unsubscribe.add(this.cartService.increaseBonusQuantityCartMethod(shopItem));

    const savedCart = this.cartService.getSessionCart()
    const sessionCartProduct = savedCart.find((p: CartProductModel) => p.productId === shopItem.reference);
    if (sessionCartProduct) 
      shopItem.labFlashBonus = sessionCartProduct.labFlashBonus;
  }

  onBonusFocus(event: FocusEvent, shopItem: ShopItemModel): void {
    const input = event.target as HTMLInputElement;
    input.dataset['prev'] = shopItem.labFlashBonus?.toString() ?? "0";
  }

  changeBonusQuantity(event: FocusEvent, shopItem: ShopItemModel): void {
    const input = event.target as HTMLInputElement;
    const numericValue = parseInt(input.value);
    const oldValue = Number(input.dataset['prev'] ?? 0);

    if (numericValue === oldValue || isNaN(numericValue) || numericValue < 0) {
      shopItem.labFlashBonus = oldValue;
    } else {
      this.unsubscribe.add(
        this.cartService.changeBonusQuantityCartMethod(shopItem, numericValue)
      );
    }

    // update prev value for the next edit
    input.dataset['prev'] = shopItem.labFlashDiscount!.toString();
  }

  removeBonusQuantityClick(shopItem: ShopItemModel): void {
    this.unsubscribe.add(this.cartService.decreaseBonusQuantityCartMethod(shopItem)); 

    const savedCart = this.cartService.getSessionCart()
    const sessionCartProduct = savedCart.find((p: CartProductModel) => p.productId === shopItem.reference);
    if (sessionCartProduct) 
      shopItem.labFlashBonus = sessionCartProduct.labFlashBonus;
    else
      shopItem.labFlashBonus = 0
  }


  getApplicableCampaignDiscountPercentage(product: ShopItemModel): number | null {
    if(product.labFlashDiscount)
      return product.labFlashDiscount
    
    const campaign = product?.quantityCampaign?.find(campaign => 
      product.productQuantity > campaign.quantity && 
      (campaign.maxQuantity === 0 || product.productQuantity <= campaign.maxQuantity) && 
      campaign.discountPercentage > 0
    );
    return campaign ? campaign.discountPercentage : null;
  }

  getDiscountCount(product: any): number {
    let count = 0;
    if (product.labDiscount && product.labDiscount > 0) count++;                      // PercDesc1 - Lab Discount
    if (this.getApplicableCampaignDiscountPercentage(product) !== null) count++;      // PercDesc1 - Quantity Discount
    if (product.discountPercentage && product.discountPercentage > 0) count++;        // PercDesc2 - Bio2 Discount
    if (product.otherDiscount && product.otherDiscount > 0) count++;                  // PercDesc3 - Other Discount
    return count;
  }  
  
  getLabPrice(product: any): number {
    if(!product.labFlashDiscount || product.labFlashDiscount == 0){
      const price = product.oldPrice - (product.oldPrice * product.labDiscount) / 100;
      return Math.round(price * 100) / 100;
    }
    else
      return product.oldPrice;
  }  
  
  getLabQuantityPrice(product: any, campaign: number): number {
    const labPrice = this.getLabPrice(product);
    const price = labPrice - (labPrice * campaign) / 100;
    return Math.round(price * 100) / 100;
  }
  
  getLabQuantityBio2Price(product: any, campaign: number): number {
    const labCampaignPrice = this.getLabQuantityPrice(product, campaign);
    const price = labCampaignPrice - (labCampaignPrice * product.discountPercentage) / 100;
    return Math.round(price * 100) / 100;
  }
  
  getFinalChainedPrice(product: any, campaign: number): number {
    const finalChainedPrice = this.getLabQuantityBio2Price(product, campaign);
    const otherDiscount = product.otherDiscount || 0;
    const price = finalChainedPrice - (finalChainedPrice * otherDiscount) / 100;
    return Math.round(price * 100) / 100;
  }
  
  hasFlashDiscount(product: any): boolean{
    if(product.labFlashDiscount)
      return true;
    else
      return false;
  }

  ngOnDestroy(): void {
    this.unsubscribe.unsubscribe();
  }

}
